import { AfterViewInit, Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[smrtsOverflowDetector]',
  standalone: false,
  exportAs: 'smrtsOverflowDetector',
})
export class OverflowDetectorDirective implements AfterViewInit {

  truncado = false;

  constructor(private elementRef: ElementRef<HTMLElement>) { }

  ngAfterViewInit(): void {
    this.check();
  }

  @HostListener('window:resize')
  check(): void {
    const el = this.elementRef.nativeElement;
    this.truncado = el.scrollWidth > el.clientWidth;
  }
}
